import { Calendar, Timer } from "lucide-react";
import { Outlet, useNavigate } from "react-router-dom";
import { EntriesTimerProvider } from "@/features/attorney/views/Entries/EntriesTimerContext";
import { useAuthCache, useSettingsCache } from "@/shared/cache";
import { AppShell } from "@/v2/components/AppShell";
import type { NavItem } from "@/v2/components/MobileBottomNav";
import { ActionsProvider } from "@/v2/contexts/ActionsProvider";
import { TimerProvider } from "@/v2/contexts/TimerProvider";

const navItems: NavItem[] = [
	{ path: "/entries", label: "Entries", icon: Timer },
	{ path: "/calendar", label: "Calendar", icon: Calendar },
];

export default function V2AttorneyLayout() {
	const { auth } = useAuthCache();
	const { settings: _settings } = useSettingsCache(); // TODO: use for prof_type display
	const navigate = useNavigate();

	return (
		<TimerProvider>
			<ActionsProvider>
				<EntriesTimerProvider>
					<AppShell
						navItems={navItems}
						userInitials={auth.initials}
						userDisplayName={auth.displayName}
						userEmail={auth.email}
						showRoleSwitcher={auth.isAdmin}
						currentRole="attorney"
						onRoleSwitch={() => navigate("/admin")}
					>
						<Outlet />
					</AppShell>
				</EntriesTimerProvider>
			</ActionsProvider>
		</TimerProvider>
	);
}
